/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function () {

  function initStickyCart() {

    const productComponent = document.querySelector("product-component");

    if (!productComponent) return;

    const cartBar = productComponent.querySelector("#cart-bar");

    const formElement =
      productComponent.querySelector("[data-product-form]");

    if (!cartBar || !formElement) return;

    // REMOVE ORIGINAL THEME LISTENER
    document.removeEventListener(
      "theme:scroll",
      productComponent.toggleCartBarOnScroll
    );

    function toggleCartBar() {

      const rect = formElement.getBoundingClientRect();

      // EARLY SHOW
      const shouldShow =
        rect.bottom < window.innerHeight * 1.6;

      cartBar.classList.toggle(
        "is-visible",
        shouldShow
      );
    }

    // RUN IMMEDIATELY
    toggleCartBar();

    // MOBILE SAFE EVENTS
    window.addEventListener("scroll", toggleCartBar, {
      passive: true
    });

    window.addEventListener("touchmove", toggleCartBar, {
      passive: true
    });

    window.addEventListener("resize", toggleCartBar);
  }

  // FAST LOAD
  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initStickyCart
    );
  } else {
    initStickyCart();
  }

})();